import ProductModule from "hooks/useRQProduct";
import EventEmitter from "./EventEmitter";

const eventEmitter = new EventEmitter<string>();

interface Product {
  value: string | number;
  label: string;
}

export const fetchProductList = () => {
  return new Promise((resolve, reject) => {
    ProductModule.useGetProductListBySequence({
      onSuccess: (data: any) => {
        if (
          typeof data === "object" &&
          data !== null &&
          "productData" in data
        ) {
          const fetchedProductList: Product[] = data.productData.map(
            (val: { product_id: string | number; name: string }) => ({
              value: val.product_id.toString(),
              label: val.name,
            })
          );
          // Emit the fetched product list event
          eventEmitter.emit("productListFetched", fetchedProductList);
          resolve(fetchedProductList);
        } else {
          console.error("Invalid data format:", data);
          reject("Invalid data format");
        }
      },
      onError: (error) => {
        console.error("Error fetching product list:", error);
        reject(error);
      },
    });
  });
};
